import { atomWithStorage } from 'jotai/utils';

export interface PatientPhone {
  phoneKey:  number;
  phoneNumber: string;
  isPrimary: boolean;
  isMobile:  boolean;
}

export interface PatientEmail {
  emailKey:     number;
  emailAddress: string;
  isPrimary:    boolean;
}

export interface PatientProfile {
  patientKey:      number;
  namePrefixCode:  string | null;
  firstName:       string | null;
  middleName:      string | null;
  lastName:        string | null;
  nameSuffixCode:  string | null;
  dateOfBirth:     string | null;  // 'YYYY-MM-DD'
  genderCode:      string | null;
  mrn:             string | null;
  emails:          PatientEmail[];
  phones:          PatientPhone[];
  addressLine1:    string | null;
  addressLine2:    string | null;
  city:            string | null;
  state:           string | null;
  zipCode:         string | null;
  country:         string | null;
  marketingOptOut: boolean;
}

/** Persisted for the logged-in session. Cleared on logout. */
export const patientProfileAtom = atomWithStorage<PatientProfile | null>('patient_profile', null);
